import { PRESCREENER_COMPLETION_KEYS } from 'client-portal/utils/prescreener/constants';
import { STEP_IDS } from 'client-portal/services/widget-steps';
import Super from './prescreener--base-category';

export default class RequestPrescreenerClientPreferences extends Super {
  stepId = STEP_IDS.PRESCREENER_CLIENT_PREFERENCES;

  get getResetKeys() {
    return {
      [PRESCREENER_COMPLETION_KEYS.CLIENT_PREFERENCES]: false,
    };
  }
}
